import { Injectable } from '@angular/core';

@Injectable()
export class CookiesDataService {
  defaultExpiryDate!: Date;

  constructor() {
    // From WorldNomads
    const d = new Date();
    this.defaultExpiryDate = new Date(
      d.getFullYear() + 1,
      d.getMonth(),
      d.getDate()
    );
  }

  /**
   * @description Get cookie value by cookie name
   * @param cookieName string
   * @returns string
   */
  get(cookieName: string): string {
    if (!document.cookie) {
      return '';
    }

    const cookies = document.cookie.split(';');
    const cookie = cookies?.find((c) => c.trim().startsWith(cookieName)) || '';
    return cookie ? cookie.split('=')[1] : '';
  }

  /**
   * @description Set cookie name and value as stings with expiryDate if not provided it defaults do 12 months
   * @param cookieName string
   * @param cookieValue string
   * @param expiryDate Date
   * @returns void
   */
  set(
    cookieName: string,
    cookieValue: string,
    expiryDate: Date = this.defaultExpiryDate
  ): void {
    const expires = `expires=${expiryDate.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue}; ${expires};`;
  }
}
